import React from "react";
import { convertTimeStampToDate } from "../../../utilities/commonFunctions/timeConversionFunctions";

const SiteUpdates = ({ system }) => {
  return (
    <React.Fragment>
      <h5>Site Updates</h5>
      <ul className="list-style-none">
        <li>
          <h6>Last Inventory Update: </h6>
          <span>
            {" "}
            {system.lastInventoryUpdateDate !== null ? convertTimeStampToDate(system.lastInventoryUpdateDate) : ""}
          </span>
        </li>
        <li>
          <h6>Last Surveyor Update: </h6>
          <span> {system.surveyDate !== null ? convertTimeStampToDate(system.surveyDate) : ""}</span>
        </li>
        <li>
          <h6>Surveyor: </h6>
          <span className="text-uppercase">
            {" "}
            {system.surveyorName !== null ? system.surveyorName.toLowerCase() : ""}
          </span>
        </li>
        <li>
          <h6>Operating Period: </h6>
          <span>
            {" "}
            {system.operatorStartMonth !== null ? system.operatorStartMonth : ""}/
            {system.operatorStartDay !== null ? system.operatorStartDay : ""} -{" "}
            {system.operatorEndMonth !== null ? system.operatorEndMonth : ""}/
            {system.operatorEndDay !== null ? system.operatorEndDay : ""}
          </span>
        </li>
        <li>
          <h6>Last IPS Update: </h6>
          <span> {system.ipsLastUpdateTs !== null ? convertTimeStampToDate(system.ipsLastUpdateTs) : ""}</span>
        </li>
        {system.disinfectDate ? (
          <li>
            <h6>System is required to disinfect as of: </h6>
            <span> {convertTimeStampToDate(system.disinfectDate)}</span>
          </li>
        ) : (
          ""
        )}
      </ul>
    </React.Fragment>
  );
};

export default SiteUpdates;
